import { BooleanEditor, EditorUtils, LookupEditor, StringEditor } from "@serenity-is/corelib";
import { confirmDialog, isEmptyOrNull, notifyError, notifySuccess, resolveUrl } from "@serenity-is/corelib/q";
import { userDefinition } from "../../../Administration/User/Authentication/Authorization";
import { DateMaskEditor } from "../../../Common/Editors/DateMaskEditor";
import { Utils } from "../../../Common/Helpers/Utils";
import { WarrantyPublicEndPointService } from "../../../ServerTypes/Warranty/Public.WarrantyPublicEndPointService";
$(function () {
    new WarrantyRegistration();
});
export class WarrantyRegistration {
    constructor() {
        var serialNumberEditor = new StringEditor($('#serialNumber'));
        var dateEditor = new DateMaskEditor($('#date'), { alias: 'mm/dd/yyyy' });
        var dealerEditor = new StringEditor($('#dealer'));
        var modelEditor = new StringEditor($('#model'));

        //var visualExplainEditor = new StringEditor($('#visualExplain'));
        //var operationExplainEditor = new StringEditor($('#operationExplain'));
        //var workmanshipExplainEditor = new StringEditor($('#workmanshipExplain'));
        //var overallExplainEditor = new StringEditor($('#overallExplain'));

        //var signatureDateEditor = new DateMaskEditor($('#signatureDate'), { alias: 'mm/dd/yyyy' });
        var customerNameEditor = new StringEditor($('#customerName'));
        var titleEditor = new StringEditor($('#title'));
        var companyNameEditor = new StringEditor($('#companyName'));
        var companyAddressEditor = new StringEditor($('#companyAddress'));
        var companyCityEditor = new StringEditor($('#companyCity'));
        var stateEditor = new LookupEditor($('#state'), { lookupKey: "Maintenance:State" })
        var zipEditor = new StringEditor($('#zip'));
        var companyPhoneEditor = new StringEditor($('#companyPhone'));
        //var companyFaxEditor = new StringEditor($('#companyFax'));
        var emailEditor = new StringEditor($('#email'));
        var mailingListEditor = new BooleanEditor($('#mailingList'));
        var today = new Date();
        dateEditor.valueAsDate = today;
        dateEditor.element.datepicker("option", "maxDate", today);

        //signatureDateEditor.valueAsDate = new Date();
        EditorUtils.setReadOnly(dealerEditor, true);
        EditorUtils.setReadOnly(modelEditor, true);
        serialNumberEditor.element.focus();

        serialNumberEditor.change(e => {
            if (!isEmptyOrNull(serialNumberEditor.value)) {
                WarrantyPublicEndPointService.CheckSerialNumber({
                    SerialNumber: serialNumberEditor.value,
                    RequestType: 2
                }, response => {
                    if (!response.IsSuccess) {
                        notifyError(response.Message);
                        dealerEditor.value = null;
                        modelEditor.value = null;
                        customerNameEditor.value = null;
                        companyNameEditor.value = null;
                        companyAddressEditor.value = null;
                        companyCityEditor.value = null;
                        stateEditor.value = null;
                        zipEditor.value = null;
                        companyPhoneEditor.value = null;
                        emailEditor.value = null;
                        serialNumberEditor.element.focus();
                    } else {
                        dealerEditor.value = response.Entity.CustomerName;
                        modelEditor.value = response.Entity.ChassisModel;
                        customerNameEditor.value = response.Entity.UContact;
                        companyNameEditor.value = response.Entity.UName;
                        companyAddressEditor.value = response.Entity.UAddress;
                        companyCityEditor.value = response.Entity.UCity;
                        stateEditor.value = response.Entity.UState;
                        zipEditor.value = response.Entity.UZip;
                        companyPhoneEditor.value = response.Entity.UPhoneNumber;
                        emailEditor.value = response.Entity.EMail;
                        //visualExplainEditor.element.focus();
                    }
                });
            } else {
                dealerEditor.value = null;
                modelEditor.value = null;
                customerNameEditor.value = null;
                companyNameEditor.value = null;
                companyAddressEditor.value = null;
                companyCityEditor.value = null;
                stateEditor.value = null;
                zipEditor.value = null;
                companyPhoneEditor.value = null;
                emailEditor.value = null;
            }
        });

        $('input[type=text], textarea').change(e => {
            let el = $(e.target);
            el.parent().find('label.error').hide();
            el.removeClass('error');
            if (isEmptyOrNull(el.val())) {
                el.addClass('error');
                el.parent().find('label.error').show();
            } 
        });

        emailEditor.change(e => {
            let el = $(e.target);
            el.parent().find('label.error').hide();
            el.removeClass('error');
            if (isEmptyOrNull(emailEditor.value)) {
                emailEditor.element.addClass('error');
                emailEditor.element.parent().find('label.error').show().text('This field is required.').attr('title', 'This field is required.');
            } else {
                if (!Utils.String.validateEmail(emailEditor.value)) {
                    emailEditor.element.addClass('error');
                    emailEditor.element.parent().find('label.error').show().text('Email is not valid').attr('title', 'Email is not valid');
                    emailEditor.element.focus();
                }
            }
        });

        $('button#warranty-registration-button').click(e => {
            var isError = false;
            $('label.error').hide();
            $('.fd-error').hide();
            $('input.error').removeClass('error');
            if (isEmptyOrNull(serialNumberEditor.value)) {
                isError = true;
                serialNumberEditor.element.addClass('error');
                serialNumberEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(dateEditor.value)) {
                isError = true;
                dateEditor.element.addClass('error');
                dateEditor.element.parent().find('.required-error').show();
            }
            if (dateEditor.valueAsDate > today) {
                isError = true;
                dateEditor.element.addClass('error');
                notifyError("The date can't be a future date.");
                $('.fd-error').show();
            }
            if (isEmptyOrNull(customerNameEditor.value)) {
                isError = true;
                customerNameEditor.element.addClass('error');
                customerNameEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(companyNameEditor.value)) {
                isError = true;
                companyNameEditor.element.addClass('error');
                companyNameEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(titleEditor.value)) {
                isError = true;
                titleEditor.element.addClass('error');
                titleEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(companyAddressEditor.value)) {
                isError = true;
                companyAddressEditor.element.addClass('error');
                companyAddressEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(companyCityEditor.value)) {
                isError = true;
                companyCityEditor.element.addClass('error');
                companyCityEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(stateEditor.value)) {
                isError = true;
                stateEditor.element.addClass('error');
                stateEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(zipEditor.value)) {
                isError = true;
                zipEditor.element.addClass('error');
                zipEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(companyPhoneEditor.value)) {
                isError = true;
                companyPhoneEditor.element.addClass('error');
                companyPhoneEditor.element.parent().find('label.error').show();
            }
            if (isEmptyOrNull(emailEditor.value)) {
                isError = true;
                emailEditor.element.addClass('error');
                emailEditor.element.parent().find('label.error').show();
            } else {
                if (!Utils.String.validateEmail(emailEditor.value)) {
                    isError = true;
                    emailEditor.element.addClass('error');
                    notifyError("Email is not valid");
                    emailEditor.element.focus();
                }
            }
            if (isError) {
                return;
            }
            confirmDialog(`Are you sure you want to Submit?`, () => {
                $('.btn').attr('disabled', 'disabled');
                $('.btn').addClass('disabled');
                WarrantyPublicEndPointService.RegisterWarranty({
                    Entity: {
                        SerialNumber: serialNumberEditor.value,
                        Date1: dateEditor.value,
                        DealerName: dealerEditor.value,
                        Model: modelEditor.value,
                        //Visual: visualExplainEditor.value,
                        //VisualRate: $("input[name='visual']:checked").val(),
                        //Operation: operationExplainEditor.value,
                        //OperationRate: $("input[name='operation']:checked").val(),
                        //Workmanship: workmanshipExplainEditor.value,
                        //WorkmanshipRate: $("input[name='workmanship']:checked").val(),
                        //Overall: overallExplainEditor.value,
                        //OverallRate: $("input[name='overall']:checked").val(),
                        //WarrantyDuration: $("input[name='warranty-duration']:checked").val(),
                        //Date2: signatureDateEditor.value,
                        CustomerName: customerNameEditor.value,
                        Title: titleEditor.value,
                        CompanyName: companyNameEditor.value,
                        Address: companyAddressEditor.value,
                        City: companyCityEditor.value,
                        State: stateEditor.value,
                        Zip: zipEditor.value,
                        Phone: companyPhoneEditor.value,
                        Email: emailEditor.value,
                        IsMailingList: mailingListEditor.value
                    }
                }, response => {
                    $('.btn').removeAttr('disabled');
                    $('.btn').removeClass('disabled');
                    if (!response.IsSuccess) {
                        notifyError(response.Message);
                    } else {
                        notifySuccess('Thank you for submitting your Warranty Registration form');
                        // Logged-in users (dealer or customer) land on their dashboard - Phase 1's
                        // routing already sorts out which one. Anonymous submitters go to the
                        // dedicated thank-you page instead, since they have no dashboard to land on.
                        const isLoggedIn = !!userDefinition().Username;
                        setTimeout(() => {
                            window.location.href = resolveUrl(isLoggedIn ? '~/' : '~/Warranty/RegistrationSuccess');
                        }, 1500);
                    }
                });
            }, {
                title: 'Confirm Submit',
                dialogClass: 's-MessageDialog s-WarningDialog'
            });
        });
    }
}